import React from 'react';
import { builtItem } from '../../../../utils/buildItem';
import './style.scss';

export const DesktopMenuOption = ({
  node,
  onClick,
  isActive = false,
  isPreviousActive = false,
}) => {
  const { text, navImage, navIcon, code, navImageActive } = node;

  return (
    <li
      className={`desktop-menu-option ${isActive ? 'node-active' : ''} ${
        isPreviousActive ? 'node-previous-active' : ''
      }`}
      onClick={onClick}
      onKeyPress={onClick}
    >
      {builtItem(isActive ? navImageActive : navImage, code, navIcon, text)}
    </li>
  );
};
